import React from 'react';
import ButtonContainer from '../components/ButtonContainer';
import { FormattedMessage } from 'react-intl';
import errorImage from '../images/Error.svg';
import WhiteboxPage from '../components/WhiteboxPage';
import TallButton from '../components/TallButton';
import styled from '@emotion/styled';
import { VerificationType } from '../types';
import {
  useAnalyticsClient,
  usePageViewedEvent,
} from '../utilities/analytics/analytics-web-client';
import { useNavigateSoftOrHard } from '../utilities/hooks/useNavigateSoftOrHard';

const MessageContainer = styled.div`
  margin-bottom: 24px;
`;

export type VerifyOrReverifyEmailInvalidTokenErrorPageProps = {
  recoverUrl: string;
  verificationType: VerificationType;
};

export const VerifyOrReverifyEmailInvalidTokenErrorPage = ({
  recoverUrl,
  verificationType,
}: VerifyOrReverifyEmailInvalidTokenErrorPageProps) => {
  const navigate = useNavigateSoftOrHard();
  const analyticsClient = useAnalyticsClient();
  const pageId = 'verifyEmailInvalidTokenErrorPage';

  usePageViewedEvent(pageId, { flow: verificationType });

  const recover = () => {
    analyticsClient.buttonClickedEvent(pageId, 'startAgain', {
      flow: verificationType,
    });

    navigate(recoverUrl);
  };

  return (
    <WhiteboxPage
      pageId={pageId}
      header={
        <div>
          <MessageContainer>
            <FormattedMessage
              id="reverify.email.invalid-token.error.title"
              defaultMessage="We couldn't verify your email"
              tagName="h5"
            />
          </MessageContainer>
          <img src={errorImage} width="99" alt="" />
        </div>
      }>
      <FormattedMessage
        id="reverify.email.invalid-token.error.main-action"
        defaultMessage="Something went wrong while trying to validate your email."
      />
      <ButtonContainer>
        <TallButton appearance="primary" id="go-back-button" isFullWidth onClick={recover}>
          <FormattedMessage
            id="reverify.email.invalid-token.error.button-text"
            defaultMessage="Go back to verify your email"
          />
        </TallButton>
      </ButtonContainer>
    </WhiteboxPage>
  );
};

export default VerifyOrReverifyEmailInvalidTokenErrorPage;
